import { createContext, useContext } from 'react';

export const ServiceDisplayDebuggerOpenContext = createContext<boolean>(false);

export function useServiceDisplayDebuggerOpen(): boolean {
  return useContext(ServiceDisplayDebuggerOpenContext);
}
